import { useRef } from 'react'
import { useElementWidth } from '~/shared/lib/use-element-width'
import { SkeletonBlock } from '~/shared/ui'

const CARD_MIN_WIDTH = 240
const CARD_GAP = 12
const HORIZONTAL_PADDING = 64 // matches Patients grid `px-8` left + right
const FALLBACK_CARDS = 3

export function LoadingSkeleton() {
  const ref = useRef<HTMLDivElement>(null)
  const width = useElementWidth(ref)
  const usable = Math.max(0, width - HORIZONTAL_PADDING)
  const cards =
    width === 0
      ? FALLBACK_CARDS
      : Math.max(2, Math.floor((usable + CARD_GAP) / (CARD_MIN_WIDTH + CARD_GAP)))

  return (
    <div
      ref={ref}
      className="flex w-full flex-col gap-4 px-8 pt-[64px]"
    >
      <div
        className="grid gap-3"
        style={{
          gridTemplateColumns: `repeat(${cards}, minmax(${CARD_MIN_WIDTH}px, 1fr))`,
        }}
      >
        {Array.from({ length: cards }, (_, i) => (
          <SkeletonBlock
            key={i}
            className="h-[396px] rounded-lg"
          />
        ))}
      </div>
      <SkeletonBlock className="h-[46px] rounded-lg" />
    </div>
  )
}
